import type { TCollectionSimple } from '@core/models'
import { getAuthorPageUrl } from '@core/routes'

import { CollectionMiniCard } from '../components/collection-mini-card'
import { getCollectionPageUrl } from '../helpers/pageUrls'

export type TCollectionMiniCardContainerProps = {
    collection: TCollectionSimple
}

export const CollectionMiniCardContainer = ({ collection }: TCollectionMiniCardContainerProps) => (
    <CollectionMiniCard
        coverSrc={collection.imageUrl}
        coverAlt={collection.title}
        title={collection.title}
        titleHref={getCollectionPageUrl({
            authorUsername: collection.authorUsername,
            slug: collection.slug,
        })}
        authorLabel={collection.authorDisplayName}
        authorHref={getAuthorPageUrl({ authorUsername: collection.authorUsername })}
    />
)
